import { render, staticRenderFns } from "./pinpaijianshe.vue?vue&type=template&id=ab606720&scoped=true"
import script from "./pinpaijianshe.vue?vue&type=script&lang=js"
export * from "./pinpaijianshe.vue?vue&type=script&lang=js"
import style0 from "./pinpaijianshe.vue?vue&type=style&index=0&id=ab606720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab606720",
  null
  
)

export default component.exports